/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { ConversationMessagesResponse, GetConversationMessagesApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getConversationMessages: build.query<ConversationMessagesResponse, GetConversationMessagesApiArg>({
      query: (queryArg) => ({
        method: 'GET',
        params: {
          limit: queryArg.limit,
          page: queryArg.page,
        },
        url: `/v1/conversations/${queryArg.conversationId}/messages`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getConversationMessagesApi };
export const { useGetConversationMessagesQuery, useLazyGetConversationMessagesQuery } = injectedRtkApi;
